import m from 'mithril'
import moment from 'moment' 
import Kindle from '../shared/kindle.js'
import Cookie from '../shared/cookie.js'
import './fuzzy.css'

var FuzzyClock = {
  COOKIE: "clockStyle",
  hourNames: ['twelve', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven'],
  minuteFormats: ['$PREV o’clock', 'five past $PREV', '$PREV ten', 'quarter after $PREV', 'twenty after $PREV', '$PREV twenty-five', '$PREV thirty', 'twenty five ’til $NEXT', 'twenty ’til $NEXT', 'quarter ’til $NEXT', 'ten ’til $NEXT', 'nearly $NEXT', '$NEXT o’clock'],
  format: function(d) {
    var minutes = d.getMinutes();
    var hours = d.getHours();
    hours = hours % 12;
    var seconds = d.getSeconds();
    var segment = Math.round(minutes / 5);
    var timeFormat = this.minuteFormats[segment];
    timeFormat = timeFormat.replace("$PREV", this.hourNames[hours % 12]);
    timeFormat = timeFormat.replace("$NEXT", this.hourNames[(hours+1)%12]);
    return timeFormat;
  },
  lastString: undefined,
  view: function(vnode) {
    var type = Cookie.get(FuzzyClock.COOKIE) || "fuzzy";
    var attrs = vnode.attrs || {};
    var timeFormat = "TIME"
    if (type == "standard") {
      timeFormat = moment().format("hh:mm")
    } else if (type == "standard24") {
      timeFormat = moment().format("HH:mm")
    } else {
      timeFormat = this.format(new Date());
    }
    var dateFormat = moment().format('dddd [the] Do');
    if (timeFormat != this.lastString) {
      Kindle.refreshScreen(true);
      this.lastString = timeFormat;   
    }
    return m("div#clock-container.clock", {class:attrs.class, onclick: attrs.onclick}, 
      m("div.date.h3", dateFormat.toUpperCase()),
      m("div.time", timeFormat.toLowerCase())
    )
  },
  oninit: function(vnode) {
    var now = new Date();
    var secondsToNextMinute = 60 - (now.getSeconds() + now.getMilliseconds() / 1000);
    var minutesToNextFuzzyMinute = now.getMinutes();
    vnode.state.timeout = setTimeout(function() {
      vnode.state.interval = setInterval(m.redraw, 60 * 1000)
      m.redraw()
    }, secondsToNextMinute * 1)
  },
  onremove: function(vnode) {
    clearTimeout(this.timeout)
    clearInterval(this.interval)
  }
}

module.exports = FuzzyClock